import { IUser } from "utils/types";
import { create } from "zustand";


interface ProfileStore {
  isEditModalOpen: boolean;
  user?: IUser;
  isSuperAdmin?: boolean;
  isCourseAdmin?: boolean;
  isUserAdmin?: boolean;
  openEditModal: () => void;
  closeEditModal: () => void;
  setUser: (user: IUser) => void;
  reset: () => void;
  getInitials: () => string;
  getName: () => string;
}

export const useProfileStore = create<ProfileStore>((set, get) => ({
  isEditModalOpen: false,
  reset: () => set({ user: undefined }),
  setUser: (user) => {
    const isUserAdmin = user?.userAdmin?.adminRole === "userAdmin" || user?.userAdmin?.adminRole === "rootAdmin"
    const isCourseAdmin = user?.userAdmin?.adminRole === "courseAdmin" || user?.userAdmin?.adminRole === "rootAdmin"
    const isSuperAdmin = user?.userAdmin?.adminRole === "superAdmin" || user?.userAdmin?.adminRole === "rootAdmin"
    set({ user, isCourseAdmin, isUserAdmin, isSuperAdmin })
  },
  openEditModal: () => set({ isEditModalOpen: true }),
  closeEditModal: () => set({ isEditModalOpen: false }),
  isCourseAdmin: false,
  isSuperAdmin: false,
  isUserAdmin: false,

  getInitials: (): string => {
    const { firstName, lastName } = get().user || {};
    return `${firstName?.charAt(0)||""}${lastName?.charAt(0) || ""}`;
  },
  getName() {
    const { firstName, lastName } = get().user || {};
    return `${lastName || ""} ${firstName||""}`
  },
}));
